import { useState, useCallback } from 'react';
import { getChatCompletion, getStreamingChatCompletion } from '../services/aiIntegrations/chatCompletion';

export function useChat(provider, model, streaming = false) {
  const [response, setResponse] = useState(null);
  const [fullResponse, setFullResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const sendMessage = useCallback(
    async (messages, options = {}) => {
      setIsLoading(true);
      setError(null);
      setResponse(null);
      setFullResponse(null);

      try {
        if (streaming) {
          let accumulated = '';
          const chunks = [];

          await getStreamingChatCompletion(
            provider,
            model,
            messages,
            (chunk) => {
              chunks?.push(chunk);
              const content = chunk?.choices?.[0]?.delta?.content || '';
              accumulated += content;
              setResponse(accumulated);
              setFullResponse([...chunks]);
            },
            (finalContent, allChunks) => {
              setResponse(finalContent);
              setFullResponse(allChunks);
              setIsLoading(false);
            },
            (err) => {
              setError(err);
              setIsLoading(false);
            },
            options
          );
        } else {
          const result = await getChatCompletion(provider, model, messages, options);
          setResponse(result);
          setFullResponse(result);
          setIsLoading(false);
        }
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    },
    [provider, model, streaming]
  );

  return { response, fullResponse, isLoading, error, sendMessage };
}
